import { navigate } from "gatsby"
import React from "react"
import { Navbar, Container, Button } from "react-bootstrap"

export default function TopNavbar() {
  const url = typeof window !== "undefined" ? window.location.pathname : ""
  const val =
    url.split("/")[1] == "python3" && url.split("/")[2] ? "/python3" : "/"
  const hist = url.split("/")[1] == "blog" ? "/" : val

  return (
    <Navbar className="mb-3">
      <Container fluid>
        <Button
          className="all-articles"
          variant="outline-dark"
          onClick={() => navigate(hist)}
        >
          ◄
        </Button>
      </Container>
    </Navbar>
  )
}
